import { useState } from "react";
import Search from "~icons/ph/magnifying-glass";
import UserPlus from "~icons/ph/user-plus";
import Users from "~icons/ph/users";
import type { AuthenticatedSnapshot } from "../../shared/types";
import { AccountReminder } from "../account/account-recovery";
import { useShell } from "../app/shell";
import { number, t } from "../i18n";
import { FriendSearch } from "../ui/components";
import { PersonRow } from "./person-row";

export function FriendsScreen({
  account: { me, friends, requests },
}: {
  account: AuthenticatedSnapshot;
}) {
  const shell = useShell();
  const [query, setQuery] = useState("");
  const incoming = requests.filter((p) => p.requested_by !== me.id);
  const friendTerm = query.trim().replace(/^@/, "").toLowerCase();
  const matchingFriends = friends.filter(
    (person) =>
      person.name.toLowerCase().includes(friendTerm) ||
      person.username.toLowerCase().includes(friendTerm),
  );
  const sortedFriends = [
    ...matchingFriends.filter((person) => person.status === "online"),
    ...matchingFriends.filter((person) => person.status !== "online"),
  ];
  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="app-screen"
      aria-label={t("الأصدقاء")}
    >
      <div className="screen-heading">
        <h1 id="friends-title">
          {t("الأصدقاء")} <small>{number(friends.length)}</small>
        </h1>
        <div className="screen-actions">
          {requests.length > 0 && (
            <button
              className="button secondary small"
              aria-description={
                incoming.length
                  ? t("طلبات الإضافة، {count} طلبات", {
                      count: number(incoming.length),
                    })
                  : undefined
              }
              onClick={() => shell.open({ kind: "requests" })}
            >
              {t("الطلبات")}
              {incoming.length > 0 && (
                <span className="count-badge" aria-hidden="true">
                  {number(incoming.length)}
                </span>
              )}
            </button>
          )}
          <button
            className="button secondary small"
            onClick={() => shell.open({ kind: "add-friend", step: "add" })}
          >
            <UserPlus width={15} height={15} aria-hidden="true" />
            {t("إضافة صديق")}
          </button>
        </div>
      </div>
      <FriendSearch value={query} onChange={setQuery} />
      {sortedFriends.length ? (
        sortedFriends.map((p) => (
          <PersonRow key={p.id} person={p} kind="friend" />
        ))
      ) : friendTerm ? (
        <div className="inline-empty">
          <Search width={24} height={24} />
          <p>{t("لا يوجد أصدقاء مطابقون.")}</p>
        </div>
      ) : (
        <div className="inline-empty screen-empty">
          <Users width={32} height={32} aria-hidden="true" />
          <p>{t("لا يوجد أصدقاء بعد.")}</p>
          <small>{t("شارك رابط حسابك، أو أضف صديقًا باسم المستخدم.")}</small>
        </div>
      )}
      <AccountReminder />
    </main>
  );
}
